import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import _ from 'lodash-es';

import callApi from '../apiService';
import objectFactory from '../objectFactory';

const initialState = {
  categories: [],
  wizardDbObjectShell: {
    controlling_instance: null,
    target_bendable_instance: null,
    table_name: 'categories',
    status: 'draft',
    raw_data: {}
  },
  status: 'idle',
};

const fetchDbObjectShells = async (options) => {
  console.log('categoriesSlice.fetchDbObjectShells() options: ', options);
  options.limit = options.limit || 'all';

  try {
    const response = await callApi('getDbObjectShells', null, { params: options });
    console.log('categoriesSlice.fetchDbObjectShells() response: ', response);
    return response.data;   // axios attribute
  } catch (error) {
    console.error('categoriesSlice.fetchDbObjectShells() error: ', error.message);
  }
};

export const getDbObjectShells = createAsyncThunk(
  'categories/getDbObjectShells',
  async (options) => {
    const response = await fetchDbObjectShells(options);
    return { tableName: options.tableName, rows: response.payload };
  }
);

const fetchCategories = async (options) => {
  console.log('categoriesSlice.fetchCategories() options: ', options);
  options.limit = options.limit || 'all';

  try {
    const response = await callApi('getCategories', { apiVersion: options?.apiVersion }, { params: options });
    console.log('categoriesSlice.fetchCategories() response: ', response);
    return response.data;   // axios attribute
  } catch (error) {
    console.error('categoriesSlice.fetchCategories() error: ', error.message);
  }
};

export const getCategories = createAsyncThunk(
  'categories/getCategories',
  async (options) => {
    console.log('categoriesSlice.getCategories() options: ', options);
    const response = await fetchCategories(options);
    console.log('categoriesSlice.getCategories() response: ', response);
    return { categories: response.payload.categories };
  }
);

export const buildWizardDbObjectShell = createAsyncThunk(
  'categories/buildWizardDbObjectShell',
  async (options) => {
    console.log('categoriesSlice buildWizardDbObjectShell() options: ', options);
    const response = await fetchCategories(options);
    console.log('categoriesSlice.buildWizardDbObjectShell() response: ', response);
    return { category: (response.payload?.categories && response.payload.categories[0]) || null };
  }
);



export const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    mergeCategoryWizardRootData: (state, action) => {
      console.log('categoriesSlice mergeCategoryWizardRootData before merge; state, action: ', current(state), action);
      // the .mergeWith() below can generate this error: Unhandled Rejection (Error): [Immer] Immer only supports setting array indices and the 'length' property
      // so let's avoid Immer with cloneDeep...
      // state.wizardDbObjectShell = _.mergeWith(state.wizardDbObjectShell, action.payload, (objValue, srcValue, key, object, source, stack) => {
      const stateCopy = _.cloneDeep(state.wizardDbObjectShell);
      const payloadCopy = _.cloneDeep(action.payload);
      state.wizardDbObjectShell = _.mergeWith(stateCopy, payloadCopy, (objValue, srcValue, key, object, source, stack) => {
        if (_.isArray(srcValue)) {
          return srcValue;              // allows empty arrays to overwrite existing arrays
        } else {
          return undefined;
        }
      });
      console.log('categoriesSlice mergeCategoryWizardRootData after merge; state: ', current(state));
    },
    mergeCategoryWizardRawData: (state, action) => {
      console.log('categoriesSlice mergeCategoryWizardRawData before merge; state, action: ', current(state), action);
      // the .mergeWith() below can generate this error: Unhandled Rejection (Error): [Immer] Immer only supports setting array indices and the 'length' property
      // so let's avoid Immer with cloneDeep...
      // state.wizardDbObjectShell.raw_data = _.mergeWith(state.wizardDbObjectShell.raw_data, action.payload, (objValue, srcValue, key, object, source, stack) => {
      const stateCopy = _.cloneDeep(state.wizardDbObjectShell.raw_data);
      console.log('categoriesSlice mergeCategoryWizardRootData stateCopy: ', stateCopy);
      const payloadCopy = _.cloneDeep(action.payload);
      console.log('categoriesSlice mergeCategoryWizardRootData payloadCopy: ', payloadCopy);
      state.wizardDbObjectShell.raw_data = _.mergeWith(stateCopy, payloadCopy, (objValue, srcValue, key, object, source, stack) => {
        // console.log('categoriesSlice mergeCategoryWizardRawData objValue: ', objValue);
        // console.log('categoriesSlice mergeCategoryWizardRawData srcValue: ', srcValue);
        // console.log('categoriesSlice mergeCategoryWizardRawData key: ', key);
        // console.log('categoriesSlice mergeCategoryWizardRawData object: ', object);
        // console.log('categoriesSlice mergeCategoryWizardRawData source: ', source);
        if (_.isArray(srcValue)) {
          return srcValue;              // allows empty arrays to overwrite existing arrays
        } else {
          return undefined;
        }
      });

      console.log('categoriesSlice mergeCategoryWizardRawData after merge; state: ', current(state));
    },
    resetCategoryWizardData: (state, action) => {
      console.log('categoriesSlice resetWizardData; state, action: ', current(state), action);
      state.wizardDbObjectShell = {
        controlling_instance: null,
        target_bendable_instance: null,
        table_name: 'categories',
        status: 'draft',
        raw_data: {},
      };
    },
  },
  extraReducers: (builder) => {
    builder
  //   .addCase(getDbObjectShells.pending, (state) => {
  //     console.log('categoriesSlice getDbObjectShells.pending state: ', state);
  //     state.status = 'loading';
  //   })
  //   .addCase(getDbObjectShells.fulfilled, (state, action) => {
  //     state.status = 'idle';
  //     console.log('categoriesSlice getDbObjectShells.fulfilled action: ', action);
  //     state.currentDbObjectShells[action.payload.tableName] = action.payload.rows;
  //     // console.log('getDbObjectShells case; state: ', current(state));
  //   });
    .addCase(getCategories.pending, (state) => {
      console.log('categoriesSlice getCategories.pending state: ', state);
      state.status = 'loading';
    })
    .addCase(getCategories.fulfilled, (state, action) => {
      state.status = 'idle';
      console.log('categoriesSlice getCategories.fulfilled action: ', action);
      state.categories = action?.payload?.categories || [];
      // console.log('getCategories case; state: ', current(state));
    })
    .addCase(buildWizardDbObjectShell.pending, (state) => {
      console.log('categoriesSlice buildWizardDbObjectShell.pending state: ', state);
      state.status = 'loading';
    })
    .addCase(buildWizardDbObjectShell.fulfilled, (state, action) => {
      state.status = 'idle';
      console.log('categoriesSlice buildWizardDbObjectShell.fulfilled action: ', action);
      const category = action?.payload?.category;
      const targetBendableInstance = action?.meta?.arg?.target_bendable_instance || 'bendable-labs';
      const dbObjectShell = objectFactory.buildDbObjectShellFromCategoryDocument(category, targetBendableInstance);
      console.log('categoriesSlice buildWizardDbObjectShell.fulfilled dbObjectShell: ', dbObjectShell);
      state.wizardDbObjectShell = dbObjectShell;  
      // console.log('buildWizardDbObjectShell case; state: ', current(state));
    });
},
});

export const {
  resetCategoryWizardData,
  mergeCategoryWizardRootData,
  mergeCategoryWizardRawData,
} = categoriesSlice.actions;

// for useSelector; state is complete store, not slice
export const selectCurrentWizardDbObjectShell = (state) => state.categories.wizardDbObjectShell;
export const selectCategories = (state) => state.categories.categories;

export default categoriesSlice.reducer;
